// import Image from 'next/image'
import AppLoader from '../app-loader/AppLoader'
import style from './AppButton.module.scss'
import { AppButtonProps } from './AppButton.types'

export default function AppButton({
  children,
  expand,
  disabled,
  theme,
  outlined,
  square,
  loading,
  size,
  onClick,
}: AppButtonProps) {
  return (
    <button
      onClick={onClick && onClick}
      className={`
        ${style.app_button}
        ${(expand && style.expand) || ''}
        ${(square && style.square) || ''}
        ${(outlined && style.outlined) || ''}
        ${(disabled && style.disabled) || ''}
        ${(theme && style[theme]) || style.primary}
        ${(size && style[size]) || style.medium}
      `}
      disabled={disabled || loading}
    >
      {/* { iconLeft && <Image src={iconLeft} alt={'icon'} width={25} height={25} /> } */}
      { !loading ? children : <AppLoader theme={ theme !== 'light' ? 'light' : 'primary'} /> }
      {/* { iconRight && <Image src={iconRight} alt={'icon'} width={25} height={25} /> } */}
    </button>
  )
}
